module.exports = __webpack_public_path__ + "static/media/ryu_0.2b23afcd.png";